import { useEffect } from 'react';

interface CategorySEOProps {
  categoryName: string;
  categorySlug: string;
}

export default function CategorySEO({ categoryName, categorySlug }: CategorySEOProps) {
  useEffect(() => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          name: `${categoryName} - 蜜桃视频`,
          url: `https://www.mitaovideo.com/category/${categorySlug}`,
          description: `浏览蜜桃视频${categoryName}分类的精选短视频内容，发现海量优质${categoryName}相关视频。`,
          isPartOf: { '@type': 'WebSite', name: '蜜桃视频', url: 'https://www.mitaovideo.com' },
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: 'https://www.mitaovideo.com',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: categoryName,
            },
          ],
        },
      ],
    };

    const scriptEl = document.createElement('script');
    scriptEl.type = 'application/ld+json';
    scriptEl.setAttribute('data-schema', `category-${categorySlug}`);
    scriptEl.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(scriptEl);

    const prevTitle = document.title;
    document.title = `${categoryName} - 蜜桃视频 | 精选${categoryName}短视频`;

    const metaDescription = document.querySelector('meta[name="description"]');
    const prevDesc = metaDescription?.getAttribute('content') || '';
    if (metaDescription) {
      metaDescription.setAttribute('content', `浏览蜜桃视频${categoryName}分类的精选短视频内容，发现海量优质${categoryName}相关视频。涵盖最新最热的${categoryName}视频资源，让您发现精彩内容。`);
    }

    return () => {
      if (scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
      document.title = prevTitle;
      if (metaDescription) metaDescription.setAttribute('content', prevDesc);
    };
  }, [categoryName, categorySlug]);

  return null;
}